import { MediaWithCarousel, MediaWithForms } from '@/components/BlackFriday'
import { HeroWideImage } from '@/components/BlackFriday/HeroWideImage'
import { Media } from '@/components/BlackFriday/Media'
import { MediaWithIcons } from '@/components/BlackFriday/MediaWithIcons'
import DatadomeScript from '@/components/Scripts/DataDome'

import { MEDIA_WITH_CAROUSEL, MEDIA_WITH_FORMS } from './constants'

const BlackFridayBlock = () => (
  <>
    <DatadomeScript />
    <HeroWideImage />
    <MediaWithCarousel {...MEDIA_WITH_CAROUSEL.CAROUSEL_VIDEOS} />
    <MediaWithForms {...MEDIA_WITH_FORMS.LINK_INTEGRITY_CHECK} />
    <MediaWithForms {...MEDIA_WITH_FORMS.FREE_DOCUMENT_CONSULTING} />
    <Media />
    <MediaWithIcons />
    <MediaWithCarousel {...MEDIA_WITH_CAROUSEL.CAROUSEL_BLOG_POSTS} />
  </>
)

export default BlackFridayBlock
